var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8AvailableUpdates50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M42 13L33 5 33 21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M34 15.999c0 0-18-.001-19 0s-1 .997-1 .997V21H8v-5.001C8 12.69 10.691 10 14 10h20V15.999zM6 35L15 43 15 27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M14,32.002c0,0,18,0,19,0c1-0.002,1-0.998,1-0.998V27h6v5.002C40,35.31,37.309,38,34,38H14V32.002z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8AvailableUpdates50);
export default __webpack_public_path__ + "static/media/icons8-available-updates-50.90b1010256593edd1f7630fa542c6b67.svg";
export { ForwardRef as ReactComponent };